import { ViewFilter } from './performance.state';
/**
 * get reports for all reps
 */
export class GetRepReports {
    static readonly type = '[Report] GetRepReports';
    constructor(public currentView: ViewFilter, public user: object, public useNewReport: boolean) { }
}

/**
 * get more groups by team
 */
 export class GetMoreTeamsToDisplay {
    static readonly type = '[Map] GetMoreTeamsToDisplay';
    constructor(public currentView: ViewFilter, public numberOfTeams: number) { }
}
